import React, { useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import ClientSelector, {
    ClientItem,
} from '../../../../../generic/ui/ClientSelector/ClientSelector'
import { AccentButton } from '../../../../../generic/ui/Button/AccentButton'
import { RootState } from '../../../../../../store/reducers/rootReducer'
import cefiLogo from '../../../../../generic/assets/cefi.png'
import Checkbox from '../../knisot/Create/Components/Checkbox'

interface Props {
    defaultCustomerID: number
    onConfirm: (customerID: number, customerFree: boolean) => void
    closeFunc?: () => void
}

const QuotationPrintCustomerModal: React.FC<Props> = ({
    defaultCustomerID,
    onConfirm,
    closeFunc,
}) => {
    const clientListDefault = useSelector(
        (s: RootState) => (s as any).defaults?.clientList?.list as ClientItem[] | null,
    )
    const clients: ClientItem[] = clientListDefault ?? []

    const [selectedCustomer, setSelectedCustomer] = useState<ClientItem | null>(
        () => clients.find((c) => +c.CustomerID === defaultCustomerID) ?? null,
    )
    const [isCustomerFree, setIsCustomerFree] = useState<boolean>(true)

    const handleConfirm = () => {
        if (!isCustomerFree && !selectedCustomer) return
        onConfirm(selectedCustomer ? +selectedCustomer.CustomerID : 0, isCustomerFree)
        closeFunc?.()
    }

    return (
        <FormShell>
            <LogoSlot>
                <Logo src={cefiLogo} alt='CEFI' />
            </LogoSlot>

            <CheckboxRow>
                <Checkbox
                    checked={isCustomerFree}
                    onChange={setIsCustomerFree}
                    label='הדפס ללא לקוח'
                />
            </CheckboxRow>

            <ClientSelector
                clients={clients}
                value={selectedCustomer}
                onSelect={(c) => setSelectedCustomer(c)}
                disabled={isCustomerFree}
            />

            <Footer>
                <AccentButton
                    type='button'
                    onClick={handleConfirm}
                    disabled={!isCustomerFree && !selectedCustomer}
                    fullWidth={false}
                >
                    הדפס
                </AccentButton>
            </Footer>
        </FormShell>
    )
}

export default QuotationPrintCustomerModal

const FormShell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    min-height: 32rem;
`

const CheckboxRow = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 0 0.25rem;
`

const LogoSlot = styled.div`
    display: flex;
    justify-content: center;
    padding: 1rem 0 0.5rem;
`

const Logo = styled.img`
    max-width: 100%;
    max-height: 13rem;
    object-fit: contain;
    user-select: none;
`

const Footer = styled.div`
    position: sticky;
    bottom: -1.25rem;
    z-index: 2;
    display: flex;
    justify-content: flex-start;
    padding: 0.75rem 0;
    margin-top: 0.5rem;
    border-top: 1px solid ${({ theme }) => theme.colors.line};
    background: ${({ theme }) => theme.colors.surface};

    button {
        min-width: 8rem;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        bottom: -1rem;
        button {
            width: 100%;
        }
    }
`
